import React, { forwardRef, useCallback, useMemo, useState } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import CrowdStrikeFalconMappingForm from './CrowdStrikeFalconMappingForm';
import { SLOW_PROJECT_LOADING_ALERT } from '../tenableCloudSecurity/TenableCloudSecurityCredentialsForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

function CrowdStrikeSpotlightCredentialsForm(props, ref) {
    const [clientSecret, setClientSecret] = useState();
    const featureFlags = useFeatureFlag();
    
    const fields = useMemo(()=>[
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        },
        {
            name: "clientId",
            label: "Client Id",
            required: true,
        },
        {
            name: "clientSecret",
            label: "Client Secret",
            required: true,
            type: FieldTypes.PASSWORD,
            props: {
                onChange: (e) => setClientSecret(e.target.value) 
            }
        },
        {
            name: "message",
            type: FieldTypes.LABEL,
            value: SLOW_PROJECT_LOADING_ALERT
        },
        ...(featureFlags.RBVM_ASSETS ? [{
                name: "fetchAssets",
                label: "Fetch Assets",
                type: FieldTypes.BOOLEAN,
                disabled: !clientSecret,
                inline: true,
        }] : []),
    ], [clientSecret, featureFlags.RBVM_ASSETS]);

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            fetchAssets: config.fetchAssets === "true"
        }
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CrowdStrikeFalconMappingForm}
            parseExtraFields={parseExtraFields}
            initialValue={{ apiEndpoint: "https://api.<region>.crowdstrike.com" }}
        />
    )
}

export default forwardRef(CrowdStrikeSpotlightCredentialsForm);